module.exports = __webpack_public_path__ + "static/media/ImageEntertainment_elBanner982162_1920_269022.b23e926a.jpg";